module.exports = __webpack_public_path__ + "img/073622.b8ea2701.png";